/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils


/* ++++++++++ --------------- EXPORT : EMBED ANALYTICS : STYLES --------------- ++++++++++ */
export default {
    embedemails: {
        '& .page': {
            width: '100%'
        },
        '& #main': {
            display: 'flex',
            flexWrap: 'wrap'
        },
        '& #content': {
          width: '100%'
        },
        '& .variant-withctas': {
            display: 'flex',
            justifyContent: 'space-between',
            '& .h3': {
                fontSize: pxToEm(34),
                fontWeight: 500
            }
        },
        '& .datepickerdropdown': {
            zIndex: 2
        },
        '& .standardpagination': {
            marginTop: pxToEm(12)
        },
        '& .export':{
            textAlign: 'right',
            marginBottom: pxToEm(8)
        }
    }
};
